import { Markdown, Spinner, ErrorState } from '@/shared/ui';
import { UI_TEXT } from '@/shared/languages';
import type { AgreementCode } from '@/shared/data-types';
import { useAgreementQuery } from '../api/use-agreement.query';

export interface AgreementContentProps {
  code: AgreementCode;
}

/**
 * 약관 원문 — 단일 약관 entity 의 표현(fetch + loading/error + 제목(`name`) + `<Markdown>` 본문).
 * 페이지·모달이 공유하는 단일 소스(가시 제목도 여기서 — FullScreenDialog title 은 sr-only). RQ
 * dedup 으로 두 표면이 같은 query 를 공유. 로딩/에러는 표준(`Spinner` / `ErrorState` + refetch).
 *
 * 제목은 응답 `name`(h1) — 본문(`content`)에는 제목 줄(`#`)이 없어야 한다. 본문은 **유효한
 * CommonMark**(선행 들여쓰기 없이) 가정하고 그대로 렌더 — FE 는 청소하지 않는다(BE content 가
 * SSOT, 결함 은폐 방지).
 */
export function AgreementContent({ code }: AgreementContentProps) {
  const { data, isPending, isError, refetch } = useAgreementQuery(code);

  if (isPending) {
    return (
      <div className="flex justify-center py-16">
        <Spinner className="size-6 text-muted-foreground" />
      </div>
    );
  }
  if (isError || !data) {
    return <ErrorState description={UI_TEXT.AGREEMENT_ERROR} onRetry={() => refetch()} />;
  }

  return <Markdown>{data.agreementContentMarkdown}</Markdown>;
}
